import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BedModel} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createBedService(dto: BedModel) {
  return await axios.post<ResponseObject<BedModel>>(`${BASEURL}/bed/createBed`, dto)
}
